import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    svgStyle: {
        width: '3.4rem',
        height: '3.4rem',
        [theme.breakpoints.down('600')]: {
            width: '3.5rem',
            height: '3.5rem'
        }
    },
}));

export default function ArrowDiagonalDown(props) {
    const classes = useStyles();

    return (
        <svg  className={classes.svgStyle} viewBox="0 0 34 34">
            <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_256" data-name="Rectangle 256" width="34" height="34" transform="translate(-147 3486)" fill="#fff" stroke="#707070" strokeWidth="1"/>
                </clipPath>
                <clipPath id="clip-path-2">
                <rect width="54.97" height="54.97" fill="none"/>
                </clipPath>
            </defs>
            <g id="Mask_Group_9" data-name="Mask Group 9" transform="translate(147 -3486)">
                <g id="Symbol_16_2" data-name="Symbol 16 – 2" transform="translate(-140.97 3458.718)">
                <path id="Path_259" data-name="Path 259" d="M1893.97,1353.5v13.126a2.5,2.5,0,0,1-2.5,2.5h0a2.5,2.5,0,0,1-2.5-2.5v-7.094l-15.8,15.8a2.5,2.5,0,1,1-3.534-3.533l15.8-15.8h-7.095a2.5,2.5,0,0,1,0-5h13.127a2.5,2.5,0,0,1,2.5,2.5Zm-34.443,28.411L1844,1397.439v-7.095a2.5,2.5,0,0,0-2.5-2.5h0a2.5,2.5,0,0,0-2.5,2.5v13.127a2.5,2.5,0,0,0,2.5,2.5h13.127a2.5,2.5,0,1,0,0-5h-7.093l15.528-15.528a2.5,2.5,0,0,0-3.534-3.534Z" transform="translate(-1839 -1351)" fill="#fff"/>
                </g>
            </g>
        </svg>
    )
}